<template lang="pug">
  .user-manage
    .container
      .row.justify-content-md-center
        .col-lg-5
          h1 ユーザー装備の編集
          .alert.alert-danger(v-if="message") {{ message }}
          .alert.alert-danger(v-if="errMessage") システムエラーが発生しました。
            div しばらく時間をおいてから再度お試しください。解決しない場合はお手数ですが
              router-link(to="/inquiry_form/input") こちら
              |よりをお問い合わせください。
          form(@submit.prevent="exec")
            .form-group
              label(for="shoes") メインシューズ
              input#shoes.form-control(type="text" placeholder="SCARPA INSTINCT VSR" v-model="shoes" maxlength='50')
            .form-group
              label(for="chalk") チョーク
              input#chalk.form-control(type="text" placeholder="東京粉末 PURE" v-model="chalk" maxlength='50')
            .form-group
              label(for="mat") メインマット
              input#mat.form-control(type="text" placeholder="MOON WARRIOR CRASH PAD" v-model="mat" maxlength='50')
            .form-group
              label(for="brush") ブラシ
              input#brush.form-control(type="text" placeholder="PAMOSTICK LONG" v-model="brush" maxlength='50')
            .form-group
              label(for="rope") ロープ
              input#rope.form-control(type="text" placeholder="PETZL MAMBO 60M" v-model="rope" maxlength='50')
            input.btn.btn-primary(type="submit" value="上記の内容で更新する" v-bind:disabled="isDisabled")
</template>
<script>
import axios from "axios";

import { Config, CognitoIdentityCredentials } from "aws-sdk";
import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute,
} from "amazon-cognito-identity-js";
export default {
  data() {
    return {
      isLogin: this.$user.isLogin,
      userId: this.$route.params.userId,
      idToken: this.$user.idToken,
      shoes: "",
      chalk: "",
      mat: "",
      brush: "",
      rope: "",
      message: "",
      errMessage: false,
      isDisabled: false,
    };
  },
  mounted() {
    //サインインしていない場合
    this.$user.cognito.getUserAttributes((err, result) => {
      if (err) {
        this.$router.push({ name: "login", query: { url: this.$route.path } }); //ページ移動
        return;
      }
      axios.get(process.env.VUE_APP_API_GATEWAY + '/api-user-info', {
        headers: {
          'Authorization': this.$user.idToken
        }
      })
        .then((response) => {
          let resp = response.data[0];
          this.shoes = resp.shoes;
          this.chalk = resp.chalk;
          this.mat = resp.mat;
          this.brush = resp.brush;
          this.rope = resp.rope;
          
        })
        .catch((err) => {
          this.falseInfo = true;
          this.isUserInfoLoading = false;
        });
    });
  },
  methods: {
    exec() {
      this.isDisabled = true;
      const url = process.env.VUE_APP_API_GATEWAY + "/api-user";
      const params = {
        shoes: this.shoes,
        chalk: this.chalk,
        mat: this.mat,
        brush: this.brush,
        rope: this.rope,
      };
      //内容送信
      axios
        .patch(url, params, {
          headers: {
            Authorization: this.$user.idToken,
          },
        })
        .then((res) => {
          this.$router.push("/myPage/" + this.$user.userId + "/userInfoTop");
          this.isDisabled = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
#app
  .container-fluid
    background #eceeef
    min-height 80vh
    //-友達リクエスト、プロフィール修正のリンク
    .top-link-area
      font-size 4vw
      .friend-riquest
        padding-right 1rem
    //-ユーザー名
    .user-name
      font-size 4.5vw
    //-バッジ、ステータス
    .status-area
      .left-box
        .status-badge
          .badge
            img
              width 100%
              height auto
              border-radius 50%
      .right-box
        margin-left -15px
        .status-name
          font-weight 600
        .status-bar
          .status-bar-innner
            display flex
            margin 0.2rem 0
            .element
              width 30%
              text-align center
              font-size 2.5vw
              font-weight 700
              padding-right 0.5rem
            .progress
              width 70%
              height 10px
              color red
              background #C3C8D9

    .bottom-text-area
      font-size 1rem
      margin-bottom 1rem
      hr
        margin 0
    //-タブエリア
    .tab-area
      .navi-container
        margin-left -15px
        margin-right -15px
        white-space nowrap
        overflow-y hidden
        overflow-x auto
        display flex
        .tab
          height 35px
          line-height 35px
          text-align center
          padding 0 0.7rem
          background #cfd3d7
          color #606e79
          cursor pointer
          border-left 0.5px solid #eceeef
          border-right 0.5px solid #eceeef
        .active
          background #004170
          color #FFF
          border-bottom 2px solid #2d8fd5

@media (min-width 992px)
  #app
    .container-fluid
      .top-link-area
        font-size 1rem
      .user-name
        font-size 1.5rem
      .bottom-text-area
        font-size 1.2rem
      //-バッジ、ステータス
      .status-area
        .left-box
          .status-badge
            .badge
              img
                max-width 150px
                width 100%
        .right-box
          width 100%
          .status-name
            font-size 1.5rem
            font-weight 600
          .status-bar
            .status-bar-innner
              display flex
              .element
                width 30%
                text-align center
                font-size 1.2rem
                font-weight 700
              .progress
                width 70%
                height 1rem
                margin-top 0.4rem
</style>
